import './App.css';
import Home from './Components/homepage/Home'
import SignIn from './Components/SignIn/SignIn'
import SignUp from './Components/SignUp/SignUp';
import {BrowserRouter, Routes, Route,} from "react-router-dom";

function App() {

  return (<>
<BrowserRouter>
    <Routes>
    <Route exact path="/signin" element={<SignIn />}/>
    <Route exact path="/" element={<Home />}/>
    <Route exact path="/signup" element={<SignUp />}/>
    </Routes>
  </BrowserRouter>

 
  </>
 );
}

export default App;
